import React, { useState } from 'react';
import { IconPlus, IconSearch, IconUpload, IconGrip } from './Icons';
import './Items.css';

export default function Items() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [columnMenuOpen, setColumnMenuOpen] = useState(false);

  const COLUMNS = [
    { key: 'title', label: 'Title' },
    { key: 'description', label: 'Description' },
    { key: 'category', label: 'Category' },
    { key: 'unitType', label: 'Unit type' },
    { key: 'rate', label: 'Rate' },
    { key: 'itemType', label: 'Item Type' },
  ];

  const [visibleColumns, setVisibleColumns] = useState(
    COLUMNS.reduce(
      (acc, col) => ({
        ...acc,
        [col.key]: true,
      }),
      {},
    ),
  );

  const toggleColumn = (key) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const activeColumns = COLUMNS.filter((col) => visibleColumns[col.key] !== false);
  const activeColumnCount = activeColumns.length + 1; // +1 for actions column

  return (
    <div className="items-page">
      <div className="items-card">
        <div className="items-header-row">
          <h1 className="items-title">Items</h1>
          <div className="items-header-actions">
            <button
              type="button"
              className="items-header-btn"
              onClick={() => setShowImportModal(true)}
            >
              <IconUpload />
              Import items
            </button>
            <button
              type="button"
              className="items-header-btn items-header-btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              <IconPlus />
              Add item
            </button>
          </div>
        </div>

        <div className="items-filters-row">
          <div className="items-filters-left">
            <div className="items-column-toggle-wrap">
              <button
                type="button"
                className="items-select-toggle items-column-toggle"
                aria-label="Choose visible columns"
                onClick={() => setColumnMenuOpen((open) => !open)}
              >
                <span className="items-column-dots">●●●</span>
              </button>

              {columnMenuOpen && (
                <div className="items-column-menu">
                  {COLUMNS.map((col) => (
                    <button
                      key={col.key}
                      type="button"
                      className={`items-column-menu-item${
                        visibleColumns[col.key] !== false ? ' active' : ''
                      }`}
                      onClick={() => toggleColumn(col.key)}
                    >
                      <span>{col.label}</span>
                      {visibleColumns[col.key] !== false && (
                        <span className="items-column-check">✓</span>
                      )}
                    </button>
                  ))}
                  <div className="items-column-menu-divider" />
                  <div className="items-column-menu-footer">
                    <IconGrip />
                  </div>
                </div>
              )}
            </div>

            <div className="items-select">- Category -</div>
            <div className="items-select">- Item Type -</div>
          </div>

          <div className="items-filters-right">
            <button type="button" className="items-utility-btn">
              Excel
            </button>
            <div className="items-search">
              <input type="text" placeholder="Search" aria-label="Search items" />
              <span className="items-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="items-table-wrapper">
          <table className="items-table">
            <thead>
              <tr>
                {activeColumns.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="items-table-empty" colSpan={activeColumnCount}>
                  No record found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="items-footer-row">
          <div className="items-footer-left">
            <select
              className="items-page-size"
              defaultValue="10"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            <span>0-0 / 0</span>
          </div>
          <div className="items-footer-right">
            <button
              type="button"
              className="items-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="items-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Add item</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowAddModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Title</div>
                <input className="estimates-form-input" placeholder="Title" />

                <div className="estimates-form-label">Item Type</div>
                <select className="estimates-form-select" defaultValue="Product">
                  <option value="Product">Product</option>
                </select>

                <div className="estimates-form-label">Description</div>
                <textarea
                  className="estimates-form-textarea"
                  placeholder="Description"
                />

                <div className="estimates-form-label">Category</div>
                <select className="estimates-form-select" defaultValue="General item">
                  <option value="General item">General item</option>
                </select>

                <div className="estimates-form-label">Unit type</div>
                <input
                  className="estimates-form-input"
                  placeholder="Unit type (Ex: hours, pc, etc.)"
                />

                <div className="estimates-form-label">Rate</div>
                <input className="estimates-form-input" placeholder="Rate" />
              </div>

            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowAddModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showImportModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowImportModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Import items</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowImportModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="estimates-modal-body">
              <div className="items-import-dropzone">
                Drag-and-drop documents here
                <br />
                (or click to browse...)
              </div>
            </div>
            <div className="estimates-modal-footer">
              <a
                href="https://iuelmpmiasitpaagowcn.supabase.co/storage/v1/object/public/sample%20project%20exel/items-sample.xlsx"
                className="estimates-footer-btn"
                download
                target="_blank"
                rel="noreferrer"
              >
                Download sample file
              </a>
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowImportModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn projects-btn-blue"
                onClick={() => setShowImportModal(false)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

